var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 17,
    viewBox: "0 0 96 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "856egz55rb",
    d: "M0 0.064L4.936 0.064 4.936 5 0 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7kyuzamoxc",
    d: "M0.601 0.518L12.66 0.518 12.66 12.578 0.601 12.578z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ampkjocaqe",
    d: "M0.803 0.519L12.706 0.519 12.706 12.578 0.803 12.578z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ofn31lv3bg",
    d: "M0.077 0.519L11.98 0.519 11.98 12.578 0.077 12.578z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2u7z0bl5vi",
    d: "M0.226 0.388L11.143 0.388 11.143 14.675 0.226 14.675z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "ts5lby5u8a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ts5lby5u8a)",
    transform: "translate(-31 -24) translate(31 24)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2837AA",
    d: "M5 2.5C5 3.88 3.88 5 2.5 5S0 3.88 0 2.5 1.12 0 2.5 0 5 1.12 5 2.5",
    transform: "translate(91 3.936)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91 3.936) translate(0 8)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7896D2",
    d: "M95.936 14.468c0 1.363-1.105 2.468-2.468 2.468S91 15.83 91 14.468 92.105 12 93.468 12s2.468 1.105 2.468 2.468"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .936) translate(41.928 2.757)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v5r1uy4jud",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7kyuzamoxc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2837AA",
    d: "M6.63 2.964c-1.977 0-3.585 1.608-3.585 3.584 0 1.977 1.608 3.585 3.585 3.585 1.977 0 3.585-1.608 3.585-3.585 0-1.976-1.608-3.584-3.585-3.584m0 9.615C3.305 12.579.6 9.873.6 6.549.6 3.223 3.306.518 6.63.518s6.03 2.705 6.03 6.03c0 3.324-2.705 6.03-6.03 6.03",
    mask: "url(#v5r1uy4jud)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .936) translate(73.373 2.757)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uwtt42mz4f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ampkjocaqe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.74 2.997c-1.721 0-2.81 1.218-3.217 2.26l-.072.179h6.651l-.069-.18c-.554-1.414-1.786-2.26-3.293-2.26m.093 9.582c-1.665 0-3.272-.7-4.41-1.922C1.267 9.417.697 7.804.817 6.113 1.03 3.106 3.558.651 6.573.524c.086-.004.17-.005.256-.005 2.498 0 4.643 1.563 5.6 4.08.436 1.145.227 2.717.225 2.733-.001.091-.052.15-.115.15H3.4l.058.173c.48 1.463 1.837 2.445 3.376 2.445 1.02 0 1.992-.438 2.664-1.202.021-.023.05-.036.081-.036.018 0 .043.004.067.024l1.788 1.381c.025.019.04.045.042.075.004.032-.006.062-.027.088-1.148 1.365-2.829 2.148-4.615 2.148",
    mask: "url(#uwtt42mz4f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .936) translate(17.82 2.757)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a58cx2uknh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ofn31lv3bg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2837AA",
    d: "M6.014 2.997c-1.721 0-2.81 1.218-3.217 2.26l-.071.179h6.65l-.069-.18c-.554-1.414-1.785-2.26-3.293-2.26m.093 9.582c-1.664 0-3.272-.7-4.41-1.922C.541 9.417-.029 7.804.092 6.113.304 3.106 2.833.651 5.847.524 5.933.52 6.018.52 6.103.52c2.498 0 4.643 1.563 5.6 4.08.437 1.145.227 2.717.225 2.733-.001.091-.052.15-.114.15h-9.14l.057.173c.48 1.463 1.837 2.445 3.376 2.445 1.02 0 1.992-.438 2.665-1.202.02-.023.049-.036.08-.036.018 0 .043.004.067.024l1.789 1.381c.024.019.038.045.042.075.003.032-.007.062-.028.088-1.147 1.365-2.829 2.148-4.615 2.148",
    mask: "url(#a58cx2uknh)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2837AA",
    d: "M16.025 7.953c0-2.583-2.095-4.678-4.68-4.678-1.304 0-2.484.535-3.333 1.399-.848-.864-2.029-1.399-3.334-1.399-.725 0-1.41.165-2.023.46l-.544-.548c-.045-.045-.106-.07-.17-.07H.238c-.132 0-.238.107-.238.238v11.742c0 .13.106.238.238.238h2.243c.132 0 .24-.107.24-.238v-7.49c.163-.933.976-1.644 1.957-1.644 1.1 0 1.99.89 1.99 1.99h.007v7.261c0 .067.055.12.12.12h2.446c.068 0 .123-.053.123-.12V7.82c.068-1.036.928-1.857 1.982-1.857 1.1 0 1.991.89 1.991 1.99h.006v7.261c0 .067.054.12.122.12h2.446c.066 0 .12-.053.12-.12v-7.26h-.006z",
    transform: "translate(0 .936)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M72.621 7.953c0-2.583-2.094-4.678-4.678-4.678-1.305 0-2.485.535-3.334 1.399-.848-.864-2.028-1.399-3.333-1.399-.783 0-1.52.193-2.17.533l-.431-.434c-.044-.044-.103-.07-.166-.07h-1.677c-.13 0-.235.107-.235.236V15.1c0 .129.104.234.235.234h2.209c.129 0 .235-.105.235-.234V7.953h.009c0-1.1.891-1.99 1.99-1.99 1.1 0 1.99.89 1.99 1.99h.007v7.261c0 .067.055.12.12.12h2.446c.067 0 .122-.053.122-.12V7.82c.07-1.036.929-1.857 1.983-1.857 1.1 0 1.992.89 1.992 1.99h.005v7.261c0 .067.054.12.122.12h2.446c.066 0 .12-.053.12-.12v-7.26h-.007z",
    transform: "translate(0 .936)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .936) translate(31.446 .66)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6by2omrlij",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2u7z0bl5vi"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2837AA",
    d: "M11.079 14.243l-5.31-5.7 5.24-5.57c.141-.15.035-.395-.17-.395H8.446c-.064 0-.126.026-.171.073l-4.55 4.835h-.882V.513c0-.07-.055-.125-.126-.125H.351C.28.388.226.443.226.513V14.55c0 .068.055.125.125.125h2.366c.07 0 .126-.057.126-.125V9.61h.897l4.615 4.953c.044.047.106.074.171.074h2.38c.206 0 .313-.244.173-.394",
    mask: "url(#6by2omrlij)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.03f42adb24ea72b6b8590a1edf3ead2c.svg";
export { ForwardRef as ReactComponent };